import { Component, ChangeDetectorRef, OnInit, HostListener } from '@angular/core';
import {AuthService} from './services/auth.service'
import { Title } from '@angular/platform-browser';  
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';  
import { filter } from 'rxjs/operators'; 
import { CustomDialogService } from './services';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'bart-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers:[DialogService,CustomDialogService]
})
export class AppComponent implements OnInit {
 constructor
  (
    private authService:AuthService,
    private router: Router,  
    private activatedRoute: ActivatedRoute,  
    private titleService: Title,
    private dialogService:CustomDialogService
  )
  {
  
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) 
  {
    this.dialogService.closeAllOpenDialog();
  }
  //Check Is Page Refreshed
  
  ngOnInit(): void 
  {
      this.router.events.pipe(  
        filter(event => event instanceof NavigationEnd),  
      ).subscribe(() => {  
        const rt = this.getChild(this.activatedRoute);  
        rt.data.subscribe(data => {  
          if(data.title!=null && data.title!=undefined)
          {
            this.titleService.setTitle("4.0 - "+data.title)
          }
        });  
      }); 
     // Start:Check Is Browser is refresed 
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          if(!this.router.navigated)
          {
            sessionStorage.removeItem("FacilityMasterId");// If Browser refreshed then clear selected FacilityMasterId-[Implemented for Water Lab]
          }
        }
      });
      // End:Check Is Browser is refresed
  }
  getChild(activatedRoute: ActivatedRoute) {  
    if (activatedRoute.firstChild) {  
      return this.getChild(activatedRoute.firstChild);  
    } else {  
      return activatedRoute;  
    }  
  
  }  
}
